module.exports = __webpack_public_path__ + "static/media/18ECA44.c6625ba6.jpg";